import { useEffect, useCallback } from 'react'
import { useSignal, batch, useComputed } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import {isLoadingCommonFilters, commonFiltersValue, isSystemBusy} from '@signals'
import { WEBBACK_V2_API } from '@constants'
import {embargoDateSubmittedFilters, isEmptyEmbargoDate} from "../@signals";


export default function useCustomDashboardFilters() {

	const data = useSignal([])
	const mustRequest = useComputed(() => !!isLoadingCommonFilters.value)

	const onSubmit = useCallback(() => {
		embargoDateSubmittedFilters.value = commonFiltersValue.peek()
		postSubmit(`${WEBBACK_V2_API}/custom-dash/embargo/context`, commonFiltersValue.value)
			.then(res => batch(() => {
				if (!res?.length)
					isEmptyEmbargoDate.value = true
				data.value = res
				isLoadingCommonFilters.value = false
			}))
			.catch(() => {
				isSystemBusy.value = true
				isLoadingCommonFilters.value = false
			})
	}, [])

	useEffect(() => {
		if(mustRequest.value) onSubmit()
	}, [mustRequest.value])


	return {
		data: data.value
	}
}